(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-quick-view"] && !Shopify.designMode) return;
  try {
    if (document.documentElement.dataset.quickViewEnhancements !== 'true') {
    document.documentElement.dataset.quickViewEnhancements = 'true';

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: Shopify.currency.active
        }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    const renderPrice = (container, variant) => {
      if (!container || !variant) return;
      const current = formatMoney(variant.price);
      const compare = variant.compare_at_price;

      if (compare && compare > variant.price) {
        container.innerHTML = `<span class="price price--sale"><span class="price__current">${current}</span><s class="price__compare">${formatMoney(compare)}</s></span>`;
      } else {
        container.innerHTML = `<span class="price"><span class="price__current">${current}</span></span>`;
      }
    };

    const selectedOptions = (inputs) => {
      const options = [];
      inputs.forEach((input) => {
        if (input.checked) {
          options[Number(input.dataset.optionPosition) - 1] = input.value;
        }
      });
      return options;
    };

    const enhanceDialog = (dialog) => {
      if (!dialog || dialog.dataset.quickViewReady === 'true') return;
      dialog.dataset.quickViewReady = 'true';

      const closeButton = dialog.querySelector('[data-quick-view-close]');
      const variantData = dialog.querySelector('[data-quick-view-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent) : [];
      const inputs = Array.from(dialog.querySelectorAll('[data-option-position]'));
      const variantIdInput = dialog.querySelector('[data-variant-id-input]');
      const addButton = dialog.querySelector('[data-quick-view-add]');
      const priceContainer = dialog.querySelector('[data-quick-view-price]');
      const image = dialog.querySelector('[data-quick-view-image]');

      const findVariant = () => {
        const options = selectedOptions(inputs);
        return variants.find((variant) => {
          return variant.options.every((option, index) => option === options[index]);
        });
      };

      const setUnavailableOptions = () => {
        const currentOptions = selectedOptions(inputs);

        inputs.forEach((input) => {
          const position = Number(input.dataset.optionPosition) - 1;
          const testOptions = [...currentOptions];
          testOptions[position] = input.value;
          const matchingVariant = variants.find((variant) => {
            return variant.options.every((option, index) => option === testOptions[index]);
          });
          const unavailable = !matchingVariant || !matchingVariant.available;

          input.dataset.unavailable = unavailable ? 'true' : 'false';
          input.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
        });
      };

      const updateVariant = () => {
        if (!inputs.length) return;
        const variant = findVariant();
        setUnavailableOptions();

        if (!variant) {
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = addButton.dataset.soldOutText;
          }
          return;
        }

        if (variantIdInput) {
          variantIdInput.value = variant.id;
        }

        renderPrice(priceContainer, variant);

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? addButton.dataset.availableText : addButton.dataset.soldOutText;
        }

        if (image && variant.featured_image?.src) {
          image.src = variant.featured_image.src;
          image.srcset = '';
        }
      };

      inputs.forEach((input) => {
        input.addEventListener('change', updateVariant);
      });

      closeButton?.addEventListener('click', () => dialog.close());

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          dialog.close();
        }
      });

      updateVariant();
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-quick-view-open]');
      if (!trigger) return;
      const dialogId = trigger.getAttribute('aria-controls');
      const dialog = document.getElementById(dialogId);
      if (!(dialog instanceof HTMLDialogElement)) return;

      event.preventDefault();
      enhanceDialog(dialog);

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-input')) {
    customElements.define(
      'quantity-input',
      class QuantityInput extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          this.querySelector('[name="minus"]')?.addEventListener('click', () => this.change(-1));
          this.querySelector('[name="plus"]')?.addEventListener('click', () => this.change(1));
        }

        change(step) {
          const min = Number(this.input.min) || 0;
          const value = Number(this.input.value) || min;
          this.input.value = Math.max(min, value + step);
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
